import React, { useEffect } from "react" 
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addPlan, updatePlan } from "service/api";
import DatatableTables from "./Plan";




const defaultValue = {
  plan: ""
}

const AddPlan = () => {
  const [formData, setData] = useState(defaultValue)
  const [selectedId, setSelectedId] = useState(null)
  const [errors, setErrors] = useState({})
  const [refreshTable, setRefreshTable] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const onValueChange = (e) => {
    setData({ ...formData, [e.target.name]: e.target.value })
    setErrors({ ...errors, [e.target.name]: "" })
  }
    
//   const[reg, setReg] = useState([]);

//   useEffect(() => {
//     const fetchRegions = async () => {
//       try {
//         const Reg = await getRegion();
//         console.log('Fetched Regions:', reg); // Debug log
//         setReg(Reg.data);
//       } catch (error) {
//         console.error('Error fetching regions:', error);
//       }
//     };

//     fetchRegions();
//   }, []);

// const validate = () => {
//   let tempErrors = {};
//   if (!formData.plan.trim()) {
//     tempErrors.plan = "Plan is required";
//   }
//   setErrors(tempErrors);
//   return Object.keys(tempErrors).length === 0;
// }



// const handleAddPlan = async (e) => {
//   e.preventDefault();

//   if (!validate()) {
//     return;
//   }

//   try {
//     await addPlan(formData);

//     toast.success("Plan added successfully.", {
//       position: "top-center",
//       autoClose: 1500,
//     });

//     setData(defaultValue);             
//     setRefreshTable((prev) => !prev);  

//   } catch (err) {
//     console.error("Error adding plan:", err);
//     toast.error("Failed to add plan. Please try again.");
//   }
// };

const validate = () => {
    let tempErrors = {}
    if (!formData.plan.trim()) {
      tempErrors.plan = "Plan is required"
    }
    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

 const handleAddOrUpdatePlan = async (e) => {
    e.preventDefault()
    if (!validate()) return

    setLoading(true) // start loading

    try {
      if (selectedId) {
        await updatePlan(selectedId, formData)
        toast.success("Plan updated successfully")
      } else {
        await addPlan(formData)
        toast.success("Plan added successfully")
      }

      setData(defaultValue)
      setSelectedId(null)
      setRefreshTable(prev => !prev)
    } catch (err) {
      console.error("Error saving plan:", err)
      toast.error("Failed to save plan. Please try again.")
    } finally {
      setLoading(false) // stop loading
    }
  }

  const handleEdit = (plan) => {
    setData({ plan: plan.plan })
    setSelectedId(plan._id)
  }

  const handleCancel = () => {
    setData(defaultValue)
    setSelectedId(null)
  }

    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title">{selectedId ? "Edit Plan" : "Add Plan"}</h4>
            {/* <Link to="/ward" className="btn btn-danger">Ward</Link> */}
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Plan Name<span style={{ color: "red" }}>*</span>
</Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.plan ? "is-invalid" : ""}`}
                          name="plan"
                          Placeholder="Enter Plan Name"
                          value={formData.plan}
                          onChange={e => onValueChange(e)}
                        />
                        {errors.plan && (
                          <div className="invalid-feedback">{errors.plan}</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                                 <div>
                    <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddOrUpdatePlan}
                      disabled={loading}
                    >
                      {loading
                        ? "Saving..."
                        : selectedId
                        ? "Update"
                        : "Save"}
                    </Button>

                    {selectedId && !loading && (
                      <Button
                        color="secondary"
                        className="w-md"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    )}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>

         <DatatableTables refresh={refreshTable} onEdit={handleEdit} />

          
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  AddPlan;
